import React, { Component } from 'react';
import { withTranslation, Translation, } from 'react-i18next';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import { View, Image, ActivityIndicator} from "react-native-web";

import HeaderPC from '../../header/HeaderPC';
import HeaderMobile from '../../header/HeaderMobile';
import HeaderTablet from '../../header/HeaderTablet';

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function LoadingPage() {




    return (

	         <div style={{backgroundColor: '#0d0222', height: viewportHeight}}>


                  {!isMobileOnly && !isTablet &&
                    <BrowserView>
                      <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center', alignItems: 'center'}}>



                        <Image source={{uri: 'https://d3van47cb9u9tj.cloudfront.net/cnispt/logo_cnispt_transp.png'}} style={{width:'480px', height: '128px', marginBottom: '40px'}}/>



                        <ActivityIndicator  animating={true} color="#fba320" />
                      </View>
                   </BrowserView>
                 }



                 {isMobileOnly &&
           			  <MobileView>
                    <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center', alignItems: 'center'}}>





                      <Image source={{uri: 'https://d3van47cb9u9tj.cloudfront.net/cnispt/logo_cnispt_transp.png'}} style={{width:'200px', height: '53px', marginBottom: '40px'}}/>


                      <ActivityIndicator  animating={true} color="#fba320" />
                    </View>
           			 </MobileView>
           			}

           			{isTablet &&
           			  <TabletView>
                      <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center', alignItems: 'center'}}>



                        <Image source={{uri: 'https://d3van47cb9u9tj.cloudfront.net/cnispt/logo_cnispt_transp.png'}} style={{width:'480px', height: '128px', marginBottom: '40px'}}/>



                        <ActivityIndicator  animating={true} color="#fba320" />
                      </View>
           			  </TabletView>
           			}








	        </div>

    )

}
